module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('form', {
    staticClass: "dropzone",
    attrs: {
      "action": _vm.url,
      "id": _vm.id
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47dfb3aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vue2-dropzone/src/index.vue
// module id = 657
// module chunks = 1